<template>
	<v-tooltip v-if="tooltip" :text="tooltip">
		<template v-slot:activator="{ props }">
			<v-btn
				v-bind="props"
				:disabled="disabled || loading"
				:loading="loading"
				:size="size"
				:variant="variant"
				:color="color"
				@click="handleClick"
				@click.stop
				:title="title || undefined"
				:style="buttonStyle"
			>
				<v-icon :size="iconSize">{{ icon }}</v-icon>
			</v-btn>
		</template>
	</v-tooltip>

	<v-btn
		v-else
		:disabled="disabled || loading"
		:loading="loading"
		:size="size"
		:variant="variant"
		:color="color"
		@click="handleClick"
		@click.stop
		:title="title || undefined"
		:style="buttonStyle"
	>
		<v-icon :size="iconSize">{{ icon }}</v-icon>
	</v-btn>
</template>

<script>
import Toast from '@/mixins/Toast.vue'

export default {
	name: 'RefreshButton',
	mixins: [Toast],
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'medium'
		},
		variant: {
			type: String,
			default: 'text'
		},
		color: {
			type: String,
			default: '#00AEEF'
		},
		title: {
			type: String,
			default: null
		},
		icon: {
			type: String,
			default: 'mdi-refresh'
		},
		iconSize: {
			type: String,
			default: 'small'
		},
		marginLeft: {
			type: String,
			default: '8px'
		},
		methodToCall: {
			type: Function,
			default: null
		},
		tooltip: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			loading: false
		}
	},
	computed: {
		buttonStyle() {
			return {
				marginLeft: this.marginLeft
			}
		}
	},
	
	methods: {
		async handleClick() {
			if (this.methodToCall) {
				try {
					this.loading = true
					await this.methodToCall()
					this.showSuccessToast('refreshSuccess')
				} catch (error) {
					console.error('Error refreshing:', error)
					this.showErrorToast('refreshError')
				}
				finally {
					this.loading = false
				}
			}
			else {
				this.$emit('click')
			}
		}
	}
}
</script>

<style scoped>
/* Add any specific styling if needed */
</style> 